import {
  Form,
  FormInstance,
  FormListFieldData,
  InputNumber,
  Select,
} from "antd";
import { useEffect, useState } from "react";
import { FaMinus } from "react-icons/fa6";
import { TbPigMoney } from "react-icons/tb";
import { TBonusType, TBonusTypesDrop } from "../../types/payment-bonuses.types";

const ClauseSingleBox = ({
  isEditMode,
  keyI,
  name,
  fields,
  form,
  index,
  deleteClause,
  options = [],
  ...restField
}: {
  keyI: number;
  isEditMode: boolean;
  name: number;
  fields: FormListFieldData[];
  form: FormInstance<any>;
  index: number;
  deleteClause: (index: number | number[]) => void;
  options?: TBonusTypesDrop[];
}) => {
  const [type, setType] = useState("");
  const [filterOptions, setFilteredOptions] = useState<TBonusTypesDrop[]>(
    options || [],
  );
  const paymentBonuses = form.getFieldValue("paymentBonuses");

  const { Option } = Select;

  console.log(options, "options");

  useEffect(() => {
    setFilteredOptions(Array.isArray(options) ? options : []);
    if (paymentBonuses[index]) {
      //check if you should open bring out predefined fields
      setType((paymentBonuses[index].bonusType || "").toLowerCase());

      // Remove selected bonuses from the options array
      const selectedOptions = paymentBonuses.map((bonuses: TBonusType) => {
        return (bonuses.bonusType || "").toLowerCase();
      });
      const getNewOptions = (Array.isArray(options) ? options : []).filter(
        (opt: TBonusTypesDrop) => {
          return !selectedOptions.includes(opt.bonusType.toLocaleLowerCase());
        },
      );
      setFilteredOptions(getNewOptions);
    }
  }, [paymentBonuses, options]);

  type TTemplateField = { fieldId: string; name: string; type: string };

  const baseOpts = Array.isArray(options)
    ? (options as Array<TBonusTypesDrop & { fields?: TTemplateField[] }>)
    : [];
  const selectedTemplate:
    | { fields?: TTemplateField[]; bonusCode?: number }
    | undefined = baseOpts.find(
    (opt) => (opt.bonusType || "").toLowerCase() === type,
  );

  const fieldsToRender: TTemplateField[] = selectedTemplate?.fields || [];

  return (
    <div className="w-full flex flex-col gap-[20px]" key={keyI}>
      {fieldsToRender.length === 0 ? (
        <div className="grid w-full items-center gap-4 grid-cols-1 md:grid-cols-[1fr_auto]">
          <Form.Item
            {...restField}
            name={[name, "bonusType"]}
            rules={[{ required: true, message: "" }]}
            className="w-full"
          >
            <Select
              disabled={!isEditMode}
              placeholder="Select Clause Type"
              className="Nunito InSel h-[44px] bg-[#ffffff] border-[1px] !border-[#D1D5DB] focus:!shadow-[0_0px_0px_1px_#ffa30094] rounded-[8px] !text-[16px] !font-[300] !text-[#667085]"
              onChange={(e) => {
                setType(e);
                const selectedBonus = (
                  Array.isArray(options) ? options : []
                ).filter((bonusObj: TBonusTypesDrop) => {
                  return bonusObj.bonusType.toLowerCase() === e;
                });

                //set bonus code to form
                form.setFieldsValue({
                  paymentBonuses: form
                    .getFieldValue("paymentBonuses")
                    .map((paymentBonus: TBonusType, i: number) =>
                      i === index
                        ? {
                            ...paymentBonus,
                            bonusCode: selectedBonus[0]?.bonusCode,
                            logicData: {
                              ...paymentBonus.logicData,
                              uniqueCode: selectedBonus[0]?.bonusCode,
                            },
                          }
                        : paymentBonus,
                    ),
                });
              }}
            >
              {filterOptions.map(
                (
                  datum: {
                    bonusCode: number;
                    bonusType: string;
                  },
                  index: number,
                ) => {
                  return (
                    <Option
                      key={datum.bonusCode}
                      value={datum.bonusType.toLowerCase()}
                      className="!p-2 "
                    >
                      <div className="flex w-full items-center gap-[5px] text-[14px] capitalize">
                        <TbPigMoney className="text-brand-darkYellow text-[18px]" />
                        {datum.bonusType}
                      </div>
                    </Option>
                  );
                },
              )}
            </Select>
          </Form.Item>
          {isEditMode && (
            <div
              className="h-[40px] w-[40px] min-w-[40px] flex items-center justify-center rounded-[8px] border-[1px] !border-[#D1D5DB] cursor-pointer focus:!shadow-[0_0px_0px_1px_#ffa30094] justify-self-end md:justify-self-auto"
              onClick={() => deleteClause(name)}
            >
              <FaMinus className="text-[#D1D5DB]" />
            </div>
          )}
        </div>
      ) : (
        <>
          <Form.Item
            {...restField}
            name={[name, "bonusType"]}
            rules={[{ required: true, message: "" }]}
            className="w-full"
          >
            <Select
              disabled={!isEditMode}
              placeholder="Select Clause Type"
              className="Nunito InSel h-[44px] bg-[#ffffff] border-[1px] !border-[#D1D5DB] focus:!shadow-[0_0px_0px_1px_#ffa30094] rounded-[8px] !text-[16px] !font-[300] !text-[#667085]"
              onChange={(e) => {
                setType(e);
                const selectedBonus = (
                  Array.isArray(options) ? options : []
                ).filter((bonusObj: TBonusTypesDrop) => {
                  return bonusObj.bonusType.toLowerCase() === e;
                });

                //set bonus code to form
                form.setFieldsValue({
                  paymentBonuses: form
                    .getFieldValue("paymentBonuses")
                    .map((paymentBonus: TBonusType, i: number) =>
                      i === index
                        ? {
                            ...paymentBonus,
                            bonusCode: selectedBonus[0]?.bonusCode,
                            logicData: {
                              ...paymentBonus.logicData,
                              uniqueCode: selectedBonus[0]?.bonusCode,
                            },
                          }
                        : paymentBonus,
                    ),
                });
              }}
            >
              {filterOptions.map(
                (
                  datum: {
                    bonusCode: number;
                    bonusType: string;
                  },
                  index: number,
                ) => {
                  return (
                    <Option
                      key={datum.bonusCode}
                      value={datum.bonusType.toLowerCase()}
                      className="!p-2 "
                    >
                      <div className="flex w-full items-center gap-[5px] text-[14px] capitalize">
                        <TbPigMoney className="text-brand-darkYellow text-[18px]" />
                        {datum.bonusType}
                      </div>
                    </Option>
                  );
                },
              )}
            </Select>
          </Form.Item>
          <div className="grid w-full items-center gap-4 grid-cols-1 md:grid-cols-[1fr_1fr_auto]">
            {fieldsToRender.map((field) => (
              <Form.Item
                {...restField}
                key={field.fieldId}
                name={[name, "logicData", field.fieldId]}
                rules={[{ required: true, message: "" }]}
                className="w-full"
              >
                <InputNumber
                  min={1}
                  className="Nunito InNum w-full h-[40px] flex items-center !px-[6px] bg-[#ffffff] border-[1px] !border-[#D1D5DB] focus-within:!shadow-[0_0px_0px_1px_#ffa30094] focus:!shadow-[0_0px_0px_1px_#ffa30094] rounded-[8px] text-[14px] !font-[300] !text-[#6B7280] "
                  placeholder={field.name}
                  readOnly={!isEditMode}
                />
              </Form.Item>
            ))}
            {isEditMode && (
              <div
                className="h-[40px] w-[40px] min-w-[40px] flex items-center justify-center rounded-[8px] border-[1px] !border-[#D1D5DB] cursor-pointer focus:!shadow-[0_0px_0px_1px_#ffa30094] justify-self-end md:justify-self-auto"
                onClick={() => deleteClause(name)}
              >
                <FaMinus className="text-[#D1D5DB]" />
              </div>
            )}
          </div>
        </>
      )}

      {form.getFieldValue("paymentBonuses").length > 1 &&
        form.getFieldValue("paymentBonuses").length !== index + 1 && (
          <div className="w-full h-[1px] bg-[#E6EAEE] "></div>
        )}
    </div>
  );
};

export default ClauseSingleBox;
